export default __webpack_public_path__ + "static/media/fb64a9d850459a5ff7272b84d88f24c5.svg";